import { Card, Skeleton, Stack } from "@mui/material";

export default function EducationSekeleton() {
    return (
        <Card className="pagelist-content" style={{ padding: "15px" }}>

            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
                <Skeleton variant="text" width={100} height={32} />
                <Skeleton variant="rectangular" width={80} height={36} />
            </Stack>
            {
                [1, 2, 3].map((item) => (
                    <Stack direction="row" alignItems="center" spacing={2} mb={2}>
                        <Stack flex={1}>
                            <Skeleton variant="rectangular" height={50} />
                        </Stack>
                    </Stack>
                ))
            }
        </Card>
    )
}
